/** The references object of all modules needed for components initialization */
var references = {
    'tradecard': require('_core_ext/pages/tradecard'),
    'postcodeanywhere': require('_core_ext/postcodeanywhere'),
};

module.exports = {
    'references' : references
};
